import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Button } from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Image1HomeExpert from '../../../src/Assets/Imgae1HomeExpert.png';
import { buttonStylesBlue, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
import Footer from '../../Components/shared/Footer/Footer';
import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import {DrawImageHomeExpert1, DrawImageHomeExpert2, DrawImageHomeExpert3, DrawImageHomeExpert4, DrawImageHomeExpert5, DrawImageHomeExpert6, DrawImageHomeExpert7, DrawImageHomeExpert8, DrawImageHomeExpert9, DrawImageHomeExpert10, DrawImageHomeExpert11, DrawImageHomeExpert12, DrawImageHomeExpert13, DrawImageHomeExpert14, DrawImageHomeExpert15,IconContainer1Home } from '../../data/SVGs';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
//DrawImageHomeExpert16, DrawImageHomeExpertExpertFace, DrawImageHomeExpertExpertFace2, DrawImageHomeExpertExpertFace3,
import useWindowSize from '../../hooks/useWindowSize';
//import CarouselComponent from './CarouselComponent';

//export function Item(itemDesc)
//{
//    Item.propTypes = {
//        itemDesc: PropTypes.any,

//    };
//    return (
//        <Paper className={classes[`paper${item.background}`]} elevation={3}>
//            <div className={classes[`paper${item.background}`]} elevation={3}>

//            </div>
//            <h2>{itemDesc.name}</h2>
//            <p>{itemDesc.description}</p>

//            <Button className="CheckButton">
//                Check it out!
//            </Button>
//        </Paper>
//    );
//}

function HomeExpert() {

    const navigate=useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    usePersistedLanguage();
    //var items = [
    //    {
    //        name: 'C.A.',
    //        //title: 'Consultant fonctionnel  SAP MM-SD ',
    //        title: 'Expert sécurité',
    //        //description: 'Je suis vraiment impressionné par High Tech Hires. En tant que freelance, j\'ai trouvé la plateforme incroyablement utile pour trouver des projets qui correspondent parfaitement à mes compétences. Grâce à leur système de matching basé sur l\'intelligence artificielle, j\'ai été connecté avec des clients qui avaient des besoins spécifiques dans mon domaine d\'expertise.',
    //        description:'Je ne peux que recommander High Tech Hires à tous les professionnels de la sécurité des systèmes qui cherchent à développer leur carrière en travaillant sur des projets stimulants et bien rémunérés. Leur plateforme et leur équipe m\'ont vraiment offert une expérience exceptionnelle et je suis reconnaissant de faire partie de leur communauté d\'experts. ',
    //        icon:<DrawImageHomeExpert16 />,
    //    },
    //    {
    //        name: 'F.A.',
    //        //title: 'Ingénieur DevOps',
    //        title: 'Master data manager',
    //        //description: 'Je suis extrêmement satisfait de mon expérience avec HTH en tant que freelance. Leur plateforme m\'a permis de trouver des projets passionnants et parfaitement alignés avec mes compétences, Leur équipe de support est également très réactive et toujours prête à répondre à mes questions. Je recommande vivement High Tech Hires à tous les freelances à la recherche d\'opportunités professionnelles stimulantes.',
    //        description:'Leur interface conviviale et intuitive facilite la gestion de mes missions. J\'ai pu suivre et mettre à jour mes jours de travail, soumettre mes rapports et à la fin du mois le système me génère automatiquement la facture en toute simplicité.',
    //        icon:<DrawImageHomeExpertExpertFace />
    //    },
    //    {
    //        name: 'R.E.',
    //        title: 'Développeur full stack React/Node JS',
    //        description:'Je recommande vivement High Tech Hires à tous les développeurs full stack freelances à la recherche de projets passionnants et d\'une plateforme fiable pour développer leur carrière. Leur approche axée sur la qualité, la transparence et le soutien aux freelances en font un choix idéal pour tirer le meilleur parti de son expertise en tant que développeur full stack.',
    //        icon:<DrawImageHomeExpertExpertFace2 />
    //    },
    //    {
    //        name: 'M.A.',
    //        title: 'Scrum master',
    //        description:'Je suis ravi de partager mon expérience positive en tant que Scrum Master avec High Tech Hires. Leur plateforme m\'a permis de trouver des opportunités de travail passionnantes et de mettre en pratique mes compétences en gestion de projets agiles. Grâce à leur système de matching efficace, j\'ai pu être mis en relation avec des équipes et des clients qui valorisent la méthodologie Scrum et qui recherchent des professionnels expérimentés dans ce domaine.',
    //        icon:<DrawImageHomeExpertExpertFace3 />
    //    }
    //];

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignSelf:'stretch',background:'white',height:'fit-content',width:'100%'}}>
                <NavbarHome />
                {device=='desktop' &&
                <div className='homeExpertf21'>
                    <a
                        href="#expert"
                        className='homeExpertf22'
                    >{i18n.t('Expert')}</a>
                    <a
                        href="#commentCM"
                        className='homeExpertf22'
                    >{i18n.t('Comment ça marche')}</a>
                    <a
                        href="#pourquoiN"
                        className='homeExpertf22'
                    >{i18n.t('Pourquoi nous?')}</a>
                    <a
                        href="#temoignage"
                        className='homeExpertf22'
                    >{i18n.t('Témoignages')}</a>
                    <a
                        href="#nosExperts"
                        className='homeExpertf22'
                    >{i18n.t('Nos experts')}</a>

                </div>
                }
                <div style={{display:'flex',flexDirection:'column',gap:'65px',alignItems:'center',alignSelf:'stretch'}}>

                    <div
                        className='frame105HomePage'
                        id='expert'
                        style={{width:'90%',marginTop:device=='desktop'?'25px':'0px'}}
                    >
                        <div className='frame106HomePage'>
                            <div className='frame107HomePage'>
                                <div className='frame108HomePage'>
                                    <h3 className='frame101HomePage'>
                                        {i18n.t('Boostez votre carrière de freelance grâce à HTH')}
                                    </h3>
                                    {device!='desktop' &&
                                    <div className='frame112HomePage'>
                                        <img
                                            src={Image1HomeExpert}
                                            style={{borderRadius:'20px'}}
                                        />
                                    </div>
                                    }
                                    <h6 className='frame110HomePage'>
                                        {i18n.t('Explorez les opportunités de missions offertes par nos clients et découvrez des projets captivants et enrichissants qui vous feront grandir.')}
                                    </h6>
                                </div>
                                <div className='frame111HomePage'>
                                    <div className="frame0HomePage">
                                        <Button
                                            variant="contained"
                                            style={{...buttonStylesBlue(false),...{
                                                height: '48px',width:device=='desktop' ? 'auto' : '100%'}}}
                                            onClick={()=>{
                                                navigate('/login');
                                            }}

                                            startIcon={<IconContainer1Home />}
                                        > {i18n.t('Trouver une mission')}
                                        </Button></div>

                                </div>
                            </div>
                            {device=='desktop' &&
                            <div className='frame112HomePage'>
                                <img
                                    src={Image1HomeExpert}
                                    style={{borderRadius:'20px'}}
                                />
                            </div>
                            }

                        </div>
                    </div>

                    <div
                        className='frame42HomePage'
                        id='expert'
                        style={{width:'90%',maxWidth:'1301px',minWidth: device=='desktop'?'700px':'200px',gap:'100px'}}
                    >
                        {device=='desktop' &&
                        <div
                            className='frame43HomePage'
                            //style={{width:'47%'}}
                        >
                            <DrawImageHomeExpert1 height={'100%'}/>
                        </div>
                        }
                        <div
                            className='frame44HomePage'
                            style={{width:'42%'}}
                        >

                            <h3 className='frame101HomePage'>{i18n.t('Sur HTH, permettez aux missions de vous trouver!')}</h3>
                            {device!='desktop' &&
                            <div
                                className='frame43HomePage'
                                //style={{width:'47%'}}
                            >
                                <DrawImageHomeExpert1 />
                            </div>
                            }
                            <h6 className='frame27HomePage frame27HomePageflex'>{i18n.t('Inscrivez-vous dès maintenant et ajoutez votre CV à notre CVthèque intelligente. Notre système effectuera un matching entre votre profil et les besoins de nos clients.')}</h6>
                            <div className='frame46HomePage'>
                                <Button
                                    variant="contained"
                                    style={{...buttonStylesBlue(false),...{width:device=='desktop'? 'auto':'100%'}}}
                                    onClick={()=>{
                                        navigate('/register');
                                    }}
                                >
                                    {i18n.t('S\'inscrire')}
                                </Button>

                            </div>
                        </div>
                    </div>

                    <div
                        className='homeExpertf1'
                        style={{width:'80%'}}
                        id='commentCM'
                    >
                        <h3 className='homeExpertf19'>
                            {i18n.t('Comment ça marche')}
                        </h3>
                        <div
                            className='homeExpertf1'
                            style={{flexDirection:device=='desktop' ? 'row' : 'column',gap:'2%',alignSelf:'stretch',marginTop: device=='desktop'?'-80px':'0px'}}
                        >
                            <div className='homeExpertf2'>
                                <div className='homeExpertf20'>
                                    <DrawImageHomeExpert3 />
                                </div>
                                <DrawImageHomeExpert2 />
                                <p className='homeExpertf3'>{i18n.t('Inscrivez vous dès maintenant et créez votre profil')}</p>
                            </div>

                            <div
                                className='homeExpertf2'
                                style={{marginTop:device=='desktop' ?'90px':'0px'}}
                            >
                                <div className='homeExpertf20'>
                                    <DrawImageHomeExpert8 />
                                </div>
                                <DrawImageHomeExpert5 />
                                <p className='homeExpertf3'>{i18n.t('Trouvez le projet que vous recherchez, ou laissez le projet vous trouver')} </p>
                            </div>

                            <div className='homeExpertf2'>
                                <div className='homeExpertf20'>
                                    <DrawImageHomeExpert9 />
                                </div>
                                <DrawImageHomeExpert6 />
                                <p className='homeExpertf3'>{i18n.t('Contractualisez et démarrez votre mission')}  </p>
                            </div>

                            <div
                                className='homeExpertf2'
                                style={{marginTop:device=='desktop' ?'112px':'0px'}}
                            >
                                <div className='homeExpertf20'>
                                    <DrawImageHomeExpert10 />
                                </div>
                                <DrawImageHomeExpert7 />
                                <p className='homeExpertf3'>{i18n.t('Validez vos CRA à la fin de chaque mois afin de générer vos factures et recevoir votre paiement')}</p>
                            </div>

                        </div>
                        <Button
                            style={{...buttonStylesBlue(false),...{width:device=='desktop'?'auto':'100%'}}}
                            onClick={()=>{
                                navigate('/demo');
                            }}
                        >{i18n.t('Demander une Démo')}</Button>

                    </div>

                    <div
                        className='homeExpertf4'
                        id='pourquoiN'
                        style={{width:device=='desktop' ?'95%':'100%',maxWidth:'1300px',minWidth:device=='desktop' ?'700px':'200px'}}
                    >
                        <div
                            className='homeExpertf9'
                            style={{width:'100%'}}
                        >
                            <h3
                                className='homeExpertf19'
                                style={{alignItems: 'flex-start'}}
                            >
                                {i18n.t('Pourquoi les freelances préfèrent HTH?')}
                            </h3>
                            {device=='desktop' &&
                            <div className='homeExpertf7'>
                                <Button
                                    style={{...buttonStylesBlue(false),...{width:'223px'}}}
                                    onClick={()=>{
                                        navigate('/login');
                                    }}
                                >
                                    {i18n.t('Trouver une mission')}
                                </Button>
                                <Button
                                    style={{...buttonStylesGreen(false),...{width:'127px'}}}
                                    onClick={()=>{
                                        navigate('/register');
                                    }}
                                >
                                    {i18n.t('S\'inscrire')}
                                </Button>
                            </div>
                            }
                        </div>

                        <div
                            className='homeExpertf10'
                            style={{
                                display: 'grid',
                                flex: '1 1 0%',
                                gridTemplateColumns: device=='desktop' ?'repeat(3, minmax(0, 1fr))':'repeat(1, minmax(0, 1fr))',
                                gridGap:'24px',
                                height: 'fit-content',
                                width:'100%',
                            }}
                        >
                            <div className='homeExpertf11'>
                                <DrawImageHomeExpert4 />
                                <div className='homeExpertf12'>
                                    <h6 className='homeExpertf13'>
                                        {i18n.t('Le bon projet pour vous')}
                                    </h6>
                                    <p className='homeExpertf14'>
                                        {i18n.t('Nous procédons rapidement et efficacement au matching de vos compétences avec les besoins de nos clients afin de vous offrir le projet idéal.')}</p>
                                </div>
                            </div>

                            <div className='homeExpertf11'>
                                <DrawImageHomeExpert11 />
                                <div className='homeExpertf12'>
                                    <h6 className='homeExpertf13'>
                                        {i18n.t('Une plateforme complète et intuitive')}
                                    </h6>
                                    <p className='homeExpertf14'>
                                        {i18n.t('Grâce à ses fonctionnalités complètes : gestion des candidatures, des missions, des CRA et factures, HTH vous aide à vous organiser et à gérer facilement vos missions.')}</p>
                                </div>
                            </div>

                            <div className='homeExpertf11'>
                                <DrawImageHomeExpert12 />
                                <div className='homeExpertf12'>
                                    <h6 className='homeExpertf13'>
                                        {i18n.t('Ne perdez pas de temps')}
                                    </h6>
                                    <p className='homeExpertf14'>
                                        {i18n.t('Grâce à nos algorithmes basés sur l\'intelligence artificielle (IA), l\'extraction et le traitement des informations sont réalisés de manière automatisée et précise.')}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div
                            className='homeExpertf10'
                            style={{
                                display: 'grid',
                                flex: '1 1 0%',
                                gridTemplateColumns: device=='desktop' ?'repeat(3, minmax(0, 1fr))':'repeat(1, minmax(0, 1fr))',
                                gridGap:'24px',
                                height: 'fit-content',
                                width:'100%'
                            }}
                        >
                            <div className='homeExpertf11'>
                                <DrawImageHomeExpert13 />
                                <div className='homeExpertf12'>
                                    <h6 className='homeExpertf13'>
                                        {i18n.t('Réseaux des Experts')}
                                    </h6>
                                    <p className='homeExpertf14'>
                                        {i18n.t('HTH réunit une communauté d\'experts spécialisés dans divers domaines de l\'informatique et des technologies de l\'information.')}
                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf11'>
                                <DrawImageHomeExpert14 />
                                <div className='homeExpertf12'>
                                    <h6 className='homeExpertf13'>
                                        {i18n.t('Vous êtes important')}
                                    </h6>
                                    <p className='homeExpertf14'>
                                        {i18n.t('Votre importance est aussi primordiale que celle de nos clients. Nous sommes là pour vous aider à créer une image qui reflète votre valeur et vos compétences professionnelles.')}                                    </p>
                                </div>
                            </div>

                            <div className='homeExpertf11'>
                                <DrawImageHomeExpert15 />
                                <div className='homeExpertf12'>
                                    <h6 className='homeExpertf13'>
                                        {i18n.t('Gardez 100% de votre taux journalier')}
                                    </h6>
                                    <p className='homeExpertf14'>
                                        {i18n.t('Nous appliquons une commission transparente sur le taux journalier facturé à nos clients. Vous conservez ainsi 100% de votre taux du marché.')}</p>
                                </div>
                            </div>
                        </div>

                        {/*<div className='homeExpertf7'>
                            <Button
                                style={{...buttonStylesBlue(false),...{width:device=='desktop'?'auto':'100%'}}}
                                onclick={()=>{
                                    navigate('/login');
                                }}
                            >
                                    Trouver une mission
                            </Button>
                            <Button
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'auto':'100%'}}}
                                onclick={()=>{
                                    navigate('/register');
                                }}
                            >
                                    S&apos;inscrire
                            </Button>
                        </div>*/}
                    </div>

                    {/*masquer pour la v1*/}
                    {/*<CarouselComponent items={items} />*/}

                    <div
                        className='homeExpertf18'
                        id='nosExperts'
                        style={{width:'80%'}}
                    >
                        <h3 className='frame101HomePage'>
                            {i18n.t('Qui sont nos Experts')}
                        </h3>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection:'column',
                                alignSelf:'stretch',
                                gap: '16px',
                                alignItems: 'center',
                            }}
                        >
                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>{i18n.t('Digital')}</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Font End Developers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Back End Developers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Full stack Developers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Apps & Mobile Developers')}
                                                    </li>
                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Web Developers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Software Developer')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Devops Enigineer')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Project managers')}
                                                    </li>
                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Scrum masters')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Product owners')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('PMI Project managers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('PMO Specialists')}
                                                    </li>
                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Scrum coaches')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('UI & UX designers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Web Designers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Web/Digital marketing')}
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>{i18n.t('Big data')}</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Data Engineers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Data Scientists')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Data Analysts')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Big Data Architects')}
                                                    </li>
                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Big Data Developers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Big Data Administrators')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Master data Managers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Business Intelligence consultants')}
                                                    </li>
                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Big Data Visualizers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Data Modelers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Data base Administrators')}
                                                    </li>
                                                    {/*<li>
                                                    PMO Specialists
                                                    </li>*/}
                                                </ul>
                                            </div>

                                            {/*<div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                    Scrum coaches
                                                    </li>
                                                    <li>
                                                    UI & UX designers
                                                    </li>
                                                    <li>
                                                    Web Designers
                                                    </li>
                                                    <li>
                                                    Web/Digital marketing
                                                    </li>
                                                </ul>
                                            </div>*/}

                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>{i18n.t('Infrastructures')}</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Infrastructure architect')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Computer park managers')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('System Engineers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Infrastructure and IT Production Directors')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t(' IT production engineers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Methods / IT quality engineers')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Database Administrators')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Network/telecom engineers')}
                                                    </li>

                                                </ul>
                                            </div>

                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>{i18n.t('SAP')}</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('SAP Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP HANA Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP Solution Manager Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP Script Consultants')}
                                                    </li>

                                                    <li>
                                                        {i18n.t('SAP Hybris Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP MM Consultants')}
                                                    </li>
                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('SAP BI')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP Crystal Report Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP Ariba Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP FICO Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('ABAP Consultants')}
                                                    </li>
                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('SAP BW Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP BASIS Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Business Object')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP HR Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP SD Consultants')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('SAPUI5 Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP NetWeaver Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP Fiori Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP CRM Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('SAP ERP Consultants')}
                                                    </li>

                                                </ul>
                                            </div>

                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>{i18n.t('Cloud')}</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Cloud Administrators')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Cloud Architects')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Cloud consultants')}
                                                    </li>

                                                </ul>
                                            </div>

                                            {/*<div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                    SAPUI5 Consultants
                                                    </li>
                                                    <li>
                                                    SAP NetWeaver
                                                    </li>
                                                    <li>
                                                    SAP Fiori Consultants
                                                    </li>
                                                    <li>
                                                    SAP CRM Consultants
                                                    </li>
                                                    <li>
                                                    SAP ERP Consultants
                                                    </li>

                                                </ul>
                                            </div>*/}

                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>{i18n.t('DevOps')}</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Devops Engineer')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('DevSecOps')}
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>{i18n.t('ERP/CRM/SCM')}</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Salesforce Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('JD Edwards Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t(' Microsoft Dynamics Consultants')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Oracle Siebel CRM Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Lawson Consultants')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Oracle Hyperion Consultants')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('WMS Consultant')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('CiviCRM Consultants')}
                                                    </li>

                                                </ul>
                                            </div>
                                            {/*<div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                    Salesforce Consultants
                                                    </li>
                                                    <li>
                                                    JD Edwards Consultants
                                                    </li>
                                                    <li>
                                                    Microsoft Dynamics Consultants
                                                    </li>

                                                </ul>
                                            </div>*/}
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>IA</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Data Miners')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('IA Developers')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Data Analysts')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Data Scientists')}
                                                    </li>

                                                </ul>
                                            </div>
                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Project Managers')}
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>

                            <Accordion style={{width:'100%',background: '#F8F9FA',borderRadius:'10px',paddingTop:'12px'}}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography><h5 className='homeExpertf16'>{i18n.t('Information Security')}</h5></Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:device=='desktop'?'24px':'0px',alignSelf:'stretch'}}>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Cybersecurity Director')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Security coordinator')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Security architect')}
                                                    </li>

                                                </ul>
                                            </div>

                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Safety Program Manager')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Security project manager')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Security development specialist')}
                                                    </li>

                                                </ul>
                                            </div>
                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Technical Security Auditor')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Cryptologists')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Cybersecurity Consultants')}
                                                    </li>

                                                </ul>
                                            </div>
                                            <div style={{width:device=='desktop'?'25%':'100%'}}>
                                                <ul className='homeExpertf17'>
                                                    <li>
                                                        {i18n.t('Security Solutions Developers')}
                                                    </li>
                                                    <li>
                                                        {i18n.t('Cybersecurity Threat Analysts')}
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </div>

                </div>

                <Footer />
            </div>
        </>
    );
}

export default HomeExpert;